import { useState } from "react";
import { useLocation } from "react-router-dom";
import { getFocus, useAtom, useGet } from "state/jotai";

import {
  active_project,
  filter_State,
  vis_mobile_nav,
  vis_showOldSlider,
} from "state/store.global";

import { favorites, compares } from "state/store.global";

import { useFetch_Colors } from "hooks/fetch/useFetch_Colors";
import { useFetch_Navigation } from "hooks/fetch/useFetch_Navigation";

import { Icon } from "assets/Icons_";
import { Logo } from "./Nav.Logo";
import { Foldout } from "./Nav.Mobile.Foldout";

import {
  Menu,
  Section,
  CarratLeft,
  CarratRight,
} from "./Nav.Mobile.style";

import NavItems from "./NavItems";

import { useBreak } from "hooks/useBreak";

import { Box } from "@mui/material";

import { _bootstrap } from "state/store.bootstrap";

import { getIsoData } from "state/jotai.isometryDataHooks";

import { _project } from "state/store.projects";

import { BackButton } from "components/Button/BackButton";

import { ETStyledButton } from "components/Button/EusButton";

import { useRotation } from "hooks/useRotation";
import { useFilter } from "hooks/useFilter";
import { useProjectLabels } from "hooks/useProjectLabels";
import { isIframeMode } from "logging/logging";
import { OverviewBack } from "components/Isometry/OverviewBack";
import { toggle_drawer } from "state/actions";

export const NavMobile = () => {
  const here = useLocation().pathname;

  const isMobile = useBreak("md_dn");

  const { pin, pid } = useGet(active_project);

  const config = getIsoData("config");

  const rotatation = useRotation();

  const { toggleFilter } = useFilter();

  const { getLabel } = useProjectLabels();

  const { clr } = useFetch_Colors();
 const toggleDrawer = useAtom(toggle_drawer)[1];
  const { nav } = useFetch_Navigation();
  const [filterState, setFilterState] = useAtom(filter_State);
  const [show, setShow] = useAtom(vis_mobile_nav);

  const compCount = useAtom(compares)[0].length;

  const likeCount = useAtom(favorites)[0].length;

  const [state, setState] = useState(false);

  const projectType = getFocus(_bootstrap, "type");

  const menus = getFocus(_project, "menuItems")?.[pin]?.[pid] ?? [];

  useGet(vis_showOldSlider);
 
  // Extract the Forside URL
  const menuItemOrder10 = menus.find((item) => item.Order === "10");

  const logoUrl = menuItemOrder10
    ? menuItemOrder10.URL
    : "https://faelledby.dk/";

  // Route checks
  const atModel = here.includes("isometry");

  const atList = here.includes("list");

  const atFavorites = here.includes("favorites");

  const atCompare = here.includes("compare");

  const atDownloads = here.includes("downloads");

  const atGallery = here.includes("gallery");
  const isIsometry = here.includes("isometry");
  const IsList    = here.includes("list");
  const IsFavourite = here.includes("favorites");
   const IsCompare = here.includes("compare");
  const iFrameEnabled = isIframeMode();
  // Filter visibility logic
  const hideFilterRoutes = [
    "compare",
    "gallery",
    "downloads",
    "unit",
  ];

  const filterShouldShow = !hideFilterRoutes.some((route) =>
    here.includes(route)
  );

  const showButtonRoutes = [
    "list",
    "compare",
    "favorites",
    "gallery",
    "downloads",
  ];

  const showButton = showButtonRoutes.some((route) =>
    here.includes(route)
  );

  // Icon configurations
  const bars = {
    color: clr.icons,
    icon: "three_bars",
    size: "xl",
    click: () => setShow(!show),
  };

  const filter = {
    size: "lg",
    icon: "filters",
    color: "#000",
  };
const clickFilter = () => {
    if (!filterState) {
      // When filter is being opened, keep the focus
      toggleDrawer("filter");
      setFilterState(true);
      setShowMenu(false);
      // setShowProperty(false);
    } else {
      // When filter is already open, remove focus
      setFilterState(false);
      toggleDrawer("filter");
      const buttons = document.querySelectorAll('button');
      buttons.forEach(button => button.blur());
    }
  };
  const renderFilterButton = () => (
    <ETStyledButton
      tabIndex="0"
      role="button"
      variant="secondary"
      padding="12px 28px"
      pin={pin}
      clr={clr}
      type={projectType}
      isMobile={isMobile}
      showButton={showButton}
      onClick={clickFilter}
    >
      <Icon
        {...filter}
        isFaIcon={true}
        skipColorChange={true}
      />

      <span
        className="paragraph1-regular"
        style={{ color: "#000" }}
      >
        {getLabel("Anvendfilter")}
      </span>

      {atList && (
        <>
          <CarratLeft />
          <CarratRight />
        </>
      )}
    </ETStyledButton>
  );

  const renderRotateButton = () => (
    <Section
      pin={pin}
      clr={clr}
      onClick={rotatation.handleRotate}
    >
      {!rotatation.turnBuilding ? (
        <>
          <Icon
            icon="rightarrowrotate"
            color="#000"
            isFaIcon={true}
            size="lg"
          />

          {getLabel("Drejbygning")}
        </>
      ) : (
        <>
          <Icon
            icon={rotatation.isrotate ? "pause" : "play"}
            color="#000"
            isFaIcon={true}
            size="lg"
          />

          {rotatation.isrotate ? "Stop" : "Play"}
        </>
      )}
    </Section>
  );

  const renderControlBox = (showRotateButton = false) => (
    <Box
      sx={{
        position: "fixed",
        top: "70px",
        left: "0px",
        width: "100%",
      }}
    >
      <Box
        sx={{
          padding: "16px 16px",
          display: "flex",
          justifyContent: "space-between",
          gap: "8px",
          backgroundColor: "#EFEFEF",
          borderRadius: "6px 6px 0px 0px",
        }}
      >
        <CarratLeft />

        <CarratRight />

        {filterShouldShow &&
          isMobile &&
          renderFilterButton()}

        {showRotateButton &&
          config?.IMAGE_SNAPFRAMES?.length > 0 &&
          atModel &&
          renderRotateButton()}
      </Box>
    </Box>
  );

  const renderCarrats = () => (
    <>
      <CarratLeft
        bgColor={clr.primary}
        shadowBg="white"
      />

      <CarratRight
        bgColor={clr.primary}
        shadowBg="white"
      />
    </>
  );
if(iFrameEnabled){
  return(
    <>
      <Foldout nav = {nav} show = {show} setShow = {setShow} />
      {/* <LanguageMenu state={state} setState={setState}/> */}
      <Menu clr = {clr} iFrameEnabled = {iFrameEnabled}> 
        <span>
          {/* <span style  = {{paddingLeft:"16px" , position:"relative"}}>
          <Logo device = "mobile" link = {logoUrl}/>
          </span> */}
          {/* {
            (
              atCompare ||
              atFavorites ||
              atDownloads ||
              atGallery) && (
                <BackButton color = {`${clr?.primary_text_passive}`}/>
            )} */}
        </span>
        {/* {(atModel || atList) && (
          !(rotatemode ) && (pin > 0 || atList) && (projectType === 'poly') && (
            <Box
              sx = {{ position: "fixed", top: "70px", left: "0px", width: "100%" }}
            >
              <Box
                sx={{
                  padding        : "16px 16px",
                  display        : "flex",
                  justifyContent : "space-between",
                  gap            : "8px",
                  backgroundColor: "#EFEFEF",
                  borderRadius   : "6px 6px 0px 0px"
                }}
              >
                 <CarratLeft></CarratLeft>
                 <CarratRight></CarratRight>
                {filterShouldShow && isMobile  &&(
                  <ETStyledButton
                   tabIndex={"0"}
                          role="button"
                  variant={"secondary"}
                  padding={"12px 28px"}
                    pin        = {pin}
                    clr        = {clr}
                    showButton = {showButton}
                    onClick    = {toggleFilter}
                  >
                    <Icon {...filter} isFaIcon = {true} skipColorChange={true} />
                    <span className="paragraph1-regular" style={{color:"#000"}}>
                    {
                      buttonsLabel?.filter(
                        (btn) => btn.UILabelProperty === "Anvendfilter"
                      )[0]?.Label || "Anvend filter"
                    }
                    </span>
                  </ETStyledButton>
                )}
                {config?.IMAGE_SNAPFRAMES?.length > 0 && atModel && !showOldSlider &&(
                  <Section
                    pin     = {pin}
                    clr     = {clr}
                    onClick = {rotatemode && isrotate ? click1 : click2}
                  >
                    <>
                      {!turnBuilding ? (
                        <>
                          <Icon
                            icon     = "rightarrowrotate"
                            color    = {"#000"}
                            isFaIcon = {true}
                            size     = "lg"
                          />{" "}
                          {
                            buttonsLabel?.filter(
                              (btn) => btn?.UILabelProperty === "Drejbygning"
                            )[0]?.Label
                            || "Drej bygning"
                          }
                        </>
                      ) : (
                        <>
                          <Icon
                            icon     = {isrotate ? "pause" : "play"}
                            color    = {"#000"}
                            isFaIcon = {true}
                            size     = "lg"
                          />{" "}
                          {isrotate ? "Stop" : "play"}
                        </>
                      )}
                    </>
                  </Section>
                )}
              </Box>
            </Box>
          )
        )} */}
           {/* { ((isMobile && (pin !== 0 || !atModel)) || projectType === "mono") && atModel && <Box sx={{ width: '100%', height: '20px', background: 'white', position: 'absolute', left: '0', bottom: '-16px', borderRadius: '6px 6px 0 0' }}></Box>} */}
       {/* {
        (projectType === 'poly' && atModel && pin === 0) &&
         <>
        <CarratLeft bgColor = {clr.primary}></CarratLeft>
        <CarratRight bgColor = {clr.primary}></CarratRight>
        </>
        } */}
       
        {
          (atModel || atList)&& (pin > 0 || atList) && projectType === 'poly' && !rotatation.rotatemode  && (
            <Box sx = {{ position: "fixed", top: "80px", left: "0px", width: "100%" }}>
              <Box
                sx={{
                  padding        : "16px 16px",
                  display        : "flex",
                  justifyContent : "space-between",
                  gap            : "8px",
                  // backgroundColor: "#EFEFEF",
                  borderRadius   : "6px 6px 0px 0px"
                }}
              >
                  <CarratLeft></CarratLeft>
                  <CarratRight></CarratRight>
                {filterShouldShow && isMobile  &&(
                  <ETStyledButton
                  variant={"secondary"}
                  padding={"12px 28px"}
                    pin        = {pin}
                    clr        = {clr}
                    showButton = {showButton}
                    onClick    = {clickFilter}
                  >
                    <Icon {...filter} isFaIcon = {true} skipColorChange={true}/>
                     <span className="paragraph1-regular" style={{color:"#000"}}>
                       {getLabel("Anvendfilter")}
                    </span>
                    { atList &&
                      <>
                      <CarratLeft></CarratLeft>
                      <CarratRight></CarratRight>
                      </>
                    }
                  </ETStyledButton>
                )}
                {/* {config?.IMAGE_SNAPFRAMES?.length > 0 && atModel && (
                  <Section
                    pin     = {pin}
                    clr     = {clr}
                    onClick = {rotatemode && isrotate ? click1 : click2}
                  >
                    <>
                      {!turnBuilding ? (
                        <>
                          <Icon
                            icon     = "rightarrowrotate"
                            color    = {"#000"}
                            isFaIcon = {true}
                            size     = "lg"
                          />{" "}
                          {
                            buttonsLabel?.filter(
                              (btn) => btn?.UILabelProperty === "Drejbygning"
                            )[0]?.Label
                            || "Drej bygning"
                          }
                        </>
                      ) : (
                        <>
                          <Icon
                            icon     = {isrotate ? "pause" : "play"}
                            color    = {"#000"}
                            isFaIcon = {true}
                            size     = "lg"
                          />{" "}
                          {isrotate ? "Stop" : "play"}
                        </>
                      )}
                    </>
                  </Section>
                )} */}
              </Box>
            </Box>
          )
        }
            {isIsometry && <OverviewBack />}
            {!isIsometry && !IsList  &&  <BackButton style={{ position: "unset", gap: "8px" }} color={"#000"} />}
            {!iFrameEnabled &&       <NavItems hideNav = {show}/>}
  

        {/* <span style = {{paddingRight:"16px" , position:"relative"}}>
            <Icon {...bars} isFaIcon={true}/>
        </span> */}
        {/* { 
          isMobile && (projectType === 'mono' || pin > 0) && !(atModel || atList) && <>
          <CarratLeft  bgColor = {clr.primary} shadowBg = {'white'}></CarratLeft>
          <CarratRight bgColor = {clr.primary} shadowBg = {'white'}></CarratRight>
        </>
        } */}
      </Menu>
    </>
  );
}
else{
return (
    <>
      <Foldout
        nav={nav}
        show={show}
        setShow={setShow}
      />

      <Menu clr={clr} iFrameEnabled = {iFrameEnabled}>
        <span>
          <span
            style={{
              paddingLeft: "16px",
              position: "relative",
            }}
          >
            <Logo device="mobile" link={logoUrl} />
          </span>

          {(atCompare ||
            atFavorites ||
            atDownloads ||
            atGallery) && (
            <BackButton
              color={`${clr?.primary_text_passive}`}
            />
          )}
        </span>

        {(atModel || atList) &&
          !rotatation.rotatemode &&
          (pin > 0 || atList) &&
          projectType === "poly" &&
          renderControlBox(false)}

        {(atModel || atList) &&
          projectType === "mono" &&
          !rotatation.rotatemode &&
          renderControlBox(true)}

        {isMobile &&
          (projectType === "mono" || pin > 0) &&
          !(atModel || atList) &&
          renderCarrats()}

        <NavItems hideNav={show} />

        <span
          style={{
            paddingRight: "16px",
            position: "relative",
          }}
        >
          <Icon {...bars} isFaIcon={true} />
        </span>

        {isMobile &&
          (projectType === "mono" || pin > 0) &&
          !(atModel || atList) &&
          renderCarrats()}
      </Menu>
    </>
  );
}
  
};